import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  todoTask: 'All',      // Controls visibility of todo tasks
  assignedTask: 'Mine',  // Controls visibility of assigned tasks
  activeFilter: 'All', // Current active filter (All, Mine, Quick Tasks, Watching)
  taskCount: 0,
  filteredCards: [], // Add filteredCards to the initial state
  myPlannerSearchText: '',
};

const plannerFilterSlice = createSlice({
  name: "plannerFilter",
  initialState,
  reducers: {
    toggleTodoTask: (state) => {
      state.todoTask = !state.todoTask;
    },
    setTodoTask: (state, action) => {
      state.todoTask = action.payload;
    },
    toggleAssignedTask: (state) => {
      state.assignedTask = !state.assignedTask;
    },
    setAssignedTask: (state, action) => {
      state.assignedTask = action.payload;
    },
    setActiveFilter: (state, action) => {
      state.activeFilter = action.payload;
    },
    setTaskCount: (state, action) => {
      state.taskCount = action.payload;
    },
    // Add reducer to set filteredCards
    setFilteredTasks: (state, action) => {
      state.filteredCards = action.payload;
    },
    // Reset all filters to default values
    resetFilters: (state) => {
      state.todoTask = true;
      state.assignedTask = true;
      state.activeFilter = "All";
    },
    setMyPlannerSearchText: (state, action) => {
      state.myPlannerSearchText = action.payload;
    },
  },
});

export const {
  toggleTodoTask,
  setTodoTask,
  toggleAssignedTask,
  setAssignedTask,
  setActiveFilter,
  resetFilters,
  setTaskCount,
  setFilteredTasks, // Export the new action
  setMyPlannerSearchText,
} = plannerFilterSlice.actions;

// Selectors
export const selectTodoTaskFilter = (state) => state.plannerFilter.todoTask;
export const selectAssignedTaskFilter = (state) => state.plannerFilter.assignedTask;
export const selectActiveFilter = (state) => state.plannerFilter.activeFilter;
export const selectTaskCount = (state) => state.plannerFilter.taskCount;
export const selectFilteredCards = (state) => state.plannerFilter.filteredCards; // Add selector for filteredCards
export const selectMyPlannerSearchText = (state) => state.plannerFilter.myPlannerSearchText;

export default plannerFilterSlice.reducer;
